/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react';
import { AiFillInfoCircle } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import useAxiosPrivate from '../../../Hooks/useAxiosPrivate';
import useLogout from '../../../Hooks/useLogout';
import {
  ChangePasswordForm,
  InputWrapper,
  InputLabel,
  PopupInput,
  UpdateButton,
  Feedbacktext,
  ErrorText,
} from './changePasswordPopupElements';

// REGEX
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%_.-]).{8,24}$/;

// Default state
const initialState = {
  oldPassword: '',
  password: '',
  password2: '',
};

const changePasswordPopup = () => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const logout = useLogout();

  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState('');

  const [state, setState] = useState(initialState);
  const [validPassword, setValidPassword] = useState(false);
  const [validMatch, setValidMatch] = useState(false);

  const signOut = async () => {
    await logout();
    navigate('/login');
  };

  const handleInput = (e) => {
    const input = e.currentTarget.name;
    const { value } = e.currentTarget;

    setState((prev) => ({ ...prev, [input]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!state.oldPassword || !state.password || !state.password2) {
      return setFeedback('Please fill all fields');
    }

    if (state.password === state.oldPassword) {
      return setFeedback('Your new password cant be same');
    }

    setLoading(true);

    axiosPrivate.post(
      '/changePassword',
      JSON.stringify({
        oldPassword: state.oldPassword,
        newPassword: state.password,
      }),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      },
    ).then((res) => {
      if (res.data.status === 'error') {
        setFeedback(res.data.message ? res.data.message : 'Something went wrong');
        setLoading(false);
      } else {
        setFeedback(res.data.message);
        setTimeout(() => {
          signOut();
        }, 1000);
      }
    }).catch((error) => {
      setLoading(false);
      setFeedback(error.response.data.message ? error.response.data.message : 'Something went wrong');
    });
  };

  // Password verification
  useEffect(() => {
    const result = PWD_REGEX.test(state.password);
    setValidPassword(result);
    const match = state.password === state.password2;
    setValidMatch(match);
  }, [state.password, state.password2]);

  // Error handling
  useEffect(() => {
    setFeedback('');
  }, [state]);

  return (
    <ChangePasswordForm onSubmit={handleSubmit}>
      <InputWrapper>
        <InputLabel htmlFor="oldPassword">Password:</InputLabel>
        <PopupInput
          value={state.oldPassword}
          autoComplete="off"
          onChange={handleInput}
          aria-describedby="uidnote"
          type="password"
          name="oldPassword"
        />
      </InputWrapper>
      <InputWrapper>
        <InputLabel htmlFor="password">New password:</InputLabel>
        <PopupInput
          value={state.password}
          autoComplete="off"
          onChange={handleInput}
          aria-describedby="uidnote"
          type="password"
          name="password"
        />
      </InputWrapper>
      {state.password && !validPassword && (
      <ErrorText id="uidnote2">
        <AiFillInfoCircle />
        &nbsp;
        4 to 24 characters.
        <br />
        Must begin with a letter.
        <br />
        Must contain an uppercase letter.
        <br />
        Must contain Symbols such !@#$%^&*.
      </ErrorText>
      )}
      <InputWrapper>
        <InputLabel htmlFor="password2">Confirm new password:</InputLabel>
        <PopupInput
          value={state.password2}
          autoComplete="off"
          onChange={handleInput}
          aria-describedby="uidnote"
          type="password"
          name="password2"
        />
      </InputWrapper>
      {state.password2 && !validMatch && (
      <ErrorText id="uidnote3">
        <AiFillInfoCircle />
        &nbsp;
        Passwords are not matching.
      </ErrorText>
      )}
      <UpdateButton disabled={!validMatch ? true : false || !validPassword || loading} type="submit">{loading ? 'Changing' : 'Change'}</UpdateButton>
      {feedback && <Feedbacktext>{feedback}</Feedbacktext>}
    </ChangePasswordForm>
  );
};

export default changePasswordPopup;
